import React from 'react'
import '../index.scss'
import { publisherNameInvalidCheck, publisherShareInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { canAmend } from '@App/helpers/permission'
import PublisherContactCondensed from '@App/kit/components/Cards/PublisherContactCondensed'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'

import { PublisherModel } from '@Entities/work/publisher-model'
import clsx from 'clsx'

interface IProps {
    data: PublisherModel
    editFunction?(): void
    removeFunction?(removingAdminPublisher: PublisherModel): void
}

const AdminPublisherCardFull = ({ data, editFunction, removeFunction }: IProps) => {
    const [showContactDetails, setShowContactDetails] = React.useState<boolean>(false)

    const toggleContact = () => {
        setShowContactDetails(!showContactDetails)
    }

    const publisherName = data.publisherName
    const publisherShare = data.publisherShare
    const amend = data.amend

    return (
        <div className="admin-publisher-card">
            <div className="head">
                <p className={clsx('bold', publisherNameInvalidCheck(publisherName) && 'red-text')}>
                    {publisherName ? stringEscapeNewlines(publisherName) : ''}
                </p>
                <div className="controls">
                    {canAmend(amend) && editFunction && (
                        <span className="small-2 medium" onClick={editFunction}>
                            Edit
                        </span>
                    )}
                    {canAmend(amend) && removeFunction && (
                        <span className="small-2 medium" onClick={() => removeFunction(data)}>
                            Remove
                        </span>
                    )}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    <span>IPI: </span>
                    <strong>{data.ipiNumber}</strong>
                </p>
                <p className="small">
                    <span>Publisher Number: </span>
                    <strong>{data.hfaPublisherNumber}</strong>
                </p>
                {data.publisherShare !== null && (
                    <>
                        <p className={clsx('small', publisherShareInvalidCheck(publisherShare) && 'red-text bold')}>
                            Publisher share:{' '}
                        </p>
                        <h1 className="percent">{publisherShare ? publisherShare : 0}</h1>
                    </>
                )}
            </div>

            {data.hfaAgreement && (
                <>
                    <div className="contact-details details small bold" onClick={toggleContact}>
                        Contact Details {showContactDetails ? '-' : '+'}
                    </div>
                    {showContactDetails && <PublisherContactCondensed showHfa={data.hfaAgreement} />}
                </>
            )}
        </div>
    )
}

export default AdminPublisherCardFull
